/**
 * Shared interface for centers (e.g. eCatalog or resource center).
 */
import { headerLevel } from '../building-blocks/header/header.module';
import { FirstLevelMenuItem, SecondLevelMenuItem } from '../api/menu-api';

export enum CenterType {
  E_CATALOG,
  RESOURCES_CENTER,
  NEWS_ARCHIVE
}

export interface CenterModule {
  getFirstLevelMenuItemFromId: (id: string) => FirstLevelMenuItem;
  getSecondLevelMenuItemFromId: (id: string) => SecondLevelMenuItem;
  updateMobileMenuHeadingAndBackButton: (
    header: HTMLElement,
    category: FirstLevelMenuItem,
    tab: SecondLevelMenuItem,
    level: headerLevel
  ) => void;
  changeHeaderMenuSelection: (
    headerElement: HTMLElement,
    categoryId: string,
    tabId: string,
    preventReload?: boolean
  ) => void;
  printPage: () => void;

  resetFilters(): void;

  updateFilterWithNewVentilator(id: string): void;
}
